module.exports = __webpack_public_path__ + "img/lupa404.2fbba8ae.svg";